import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import Card from "../../../components/Card";
import Imagen1 from "../../../images/modulo12/postamedica.png";
import Imagen2 from "../../../images/modulo12/camiones.png";

import GuiaDocente from "../../../components/GuiaDocente";
import InputRadioButton from "../../../components/InputRadioButton";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad2Actividad6.mp3";

const Actividad9 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "option3" },
    ans2: { value: "", valid: "", correctValue: "option2" },
    ans3: { value: "", valid: "", correctValue: "option2" },
  });
  const infoUnidad = modulo12.content[1];
  const infoAct = modulo12.content[1].activities[7];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo12.content[1].name}: ${modulo12.content[1].activities[8].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[8].path}`,
    titlePrev: `${modulo12.content[1].name}: ${modulo12.content[1].activities[6].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[6].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };
  const handleAnswer = (label, value) => {
    setAnswers({
      ...answers,
      [label]: { ...answers[label], value },
    });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-md-10 col-12 p-0">
          <ul>
            <li>Lee los siguientes casos y observa las imágenes:</li>
          </ul>
        </div>
      </div>

      <Card>
        <div className="row align-items-center">
          <div className="col-md-6 col-12 p-4 p-md-0">
            <p className="fs-5">
              Benito Guadalupe estudió en una escuela rural en Chincha. Sus
              papás no podían pagarle la universidad. Benito consiguió una beca
              para pagar sus estudios y ahora es doctor.
            </p>
          </div>
          <div className="col-md-6 col-12">
            <img src={Imagen1} className="img-fluid" alt="Peruanos" />
          </div>
        </div>
      </Card>

      <Card>
        <div className="row align-items-center">
          <div className="col-md-6 col-12 p-4 p-md-0">
            <p className="fs-5">
              Walter Talancha fue a la escuela en Lima. Sus padres lograron
              ahorrar para sus estudios universitarios. Ahora Walter trabaja en
              una empresa de camiones de carga.
            </p>
          </div>
          <div className="col-md-6 col-12">
            <img src={Imagen2} className="img-fluid" alt="Peruanos" />
          </div>
        </div>
      </Card>

      <ul className="mt-5">
        <li>Ahora, marca la opción que prefieres:</li>
      </ul>

      <div className="mb-3">
        <InputRadioButton
          ans={answers.ans1}
          label="ans1"
          value="option1"
          text="Me parece bien que algunas personas que lo necesitan reciban ayuda
              para terminar sus estudios."
          handleAnswer={handleAnswer}
        />
        <InputRadioButton
          ans={answers.ans1}
          label="ans1"
          value="option2"
          text=" No me parece bien que solo algunas personas reciban ayuda. La ayuda
            debe ser para todos."
          handleAnswer={handleAnswer}
        />
      </div>
      <ul>
        <li>
          Múestrale tus respuestas a un compañero, compañera o familiar y
          pregúntale qué opción marcaría. Conversen sobre el tema.
        </li>
      </ul>

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: Lee los siguientes casos y observa las
            imágenes. Pregunte a niños y niñas qué ven en las imágenes. Por
            ejemplo:
            <ul>
              <li>
                <i>
                  “¿Qué podemos observar en la primera imagen? (Posible
                  respuesta: Vemos a un doctor frente a una posta médica.
                  Probablemente sea el lugar donde trabaja. El doctor está
                  recordando cuando iba a su escuela).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué observamos en la segunda imagen? (Vemos a un señor frente
                  a dos camiones. Parece que está orgulloso de mostrarlos.
                  Probablemente sea el dueño de esos camiones)”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Pida a un niño o niña que lea en voz alta el primer caso: Benito
            Guadalupe estudió en una escuela rural en Chincha. Sus papás no
            podían pagarle la universidad. Benito consiguió una beca para pagar
            sus estudios y ahora es doctor. Luego, pida a un estudiante que lea
            en voz alta el segundo caso: Walter Talancha fue a la escuela en
            Lima. Sus padres lograron ahorrar para sus estudios universitarios.
            Ahora Walter trabaja en una empresa de camiones de carga. Pregunte en qué se diferencian los dos casos. Retome las
            respuestas dadas parafraseándolas. Por ejemplo:
            <ul>
              <li>
                <i>
                  “En el primer caso, Benito viene de una familia con menos
                  recursos que la de Walter. La familia de Benito no pudo
                  pagarle la universidad, a diferencia de la familia de Walter.
                  A pesar de ello, gracias a un sistema de becas, Benito logró
                  ir a la universidad”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea la segunda indicación y las opciones: "Ahora, marca la opción
            que prefieres:"
          </li>

          <li>
            Después de que los niños y niñas hayan marcado su
            opción lea la última indicación:
            Compara tu respuesta con la de un compañero, compañera o familiar y conversen
            sobre el tema. Recuerde a niños y niñas que no hay una opción mejor
            que otra. De lo que se trata es de encontrar razones por las cuales
            la opción elegida es buena. Pida a algunos niños y las niñas que
            compartan la conversación con el resto de la clase. Por ejemplo:
            <ul>
              <li>
                <i>
                  “Daniela, cuéntanos el diálogo que tuviste con tu compañera”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Finalmente, señale a niños y niñas que casos como estos pueden verse
            en nuestro país, pero también existen muchas personas que no cuentan
            con becas ni ahorros y por ello no pueden acceder a estudios
            superiores. Ello es un ejemplo de desigualdad.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
